export default "__VITE_ASSET__QvR2CqIL__"